(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
  // ---------- Ajaxinate (load more / infinite scroll) ----------
  const getpagi = document.querySelector('.AjaxinatePagination');
  if (typeof getpagi !== 'undefined' && getpagi !== null) {
    document.addEventListener('DOMContentLoaded', function () {
      const elem = getpagi.getAttribute('data-pagination');
      new Ajaxinate({
        container: '.AjaxinateLoop',
        pagination: '.AjaxinatePagination',
        loadingText: '<span class="loader-line"></span>',
        method: elem === 'scroll' ? 'scroll' : 'click'
      });
    });
  }

  // ---------- Raster- of lijstweergave (met voorkeur onthouden) ----------
  document.addEventListener('DOMContentLoaded', function () {
    var wrap = document.querySelector('.col-view');
    if (!wrap) return;

    function toepassen(view) {
      var grid = document.getElementById('product-grid');
      if (grid) grid.setAttribute('data-view', view);
      var knoppen = wrap.querySelectorAll('.col-view__btn');
      Array.prototype.forEach.call(knoppen, function (b) {
        b.classList.toggle('active', b.getAttribute('data-view') === view);
        b.setAttribute('aria-pressed', b.getAttribute('data-view') === view ? 'true' : 'false');
      });
    }

    var bewaard;
    try { bewaard = localStorage.getItem('collection-view'); } catch (e) {}
    toepassen(bewaard === 'list' ? 'list' : 'grid');

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.col-view__btn') : null;
      if (!btn) return;
      var view = btn.getAttribute('data-view');
      toepassen(view);
      try { localStorage.setItem('collection-view', view); } catch (err) {}
    });

    // Na AJAX-filteren of 'meer laden' wordt de grid vervangen: weergave opnieuw zetten
    var container = document.getElementById('ProductGridContainer');
    if (container && window.MutationObserver) {
      new MutationObserver(function () {
        var voorkeur;
        try { voorkeur = localStorage.getItem('collection-view'); } catch (e) {}
        var g = document.getElementById('product-grid');
        var gewenst = voorkeur === 'list' ? 'list' : 'grid';
        if (g && g.getAttribute('data-view') !== gewenst) toepassen(gewenst);
      }).observe(container, { childList: true, subtree: true });
    }
  });

  // ---------- Aantal-teller op de productkaart ----------
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.pcard__qty-btn');
    if (!btn) return;
    var input = btn.parentNode.querySelector('.pcard__qty-input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-step'), 10) || 1;
    var value = (parseInt(input.value, 10) || 1) + step;
    if (value < 1) value = 1;
    if (value > 99) value = 99;
    input.value = value;
  });

  // ---------- 'Lees meer' onder de collectietekst ----------
  document.addEventListener('DOMContentLoaded', function () {
    var introS = document.querySelectorAll('[data-intro]');
    Array.prototype.forEach.call(introS, function (intro) {
      var toggle = intro.parentNode.querySelector('[data-intro-toggle]');
      if (!toggle) return;
      intro.setAttribute('data-clamped', 'true');
      // Knop alleen tonen als de tekst echt wordt afgekapt
      if (intro.scrollHeight - intro.clientHeight < 4) {
        intro.removeAttribute('data-clamped');
        return;
      }
      toggle.hidden = false;
      toggle.textContent = intro.getAttribute('data-more');
      toggle.addEventListener('click', function () {
        var ingeklapt = intro.getAttribute('data-clamped') === 'true';
        if (ingeklapt) {
          intro.removeAttribute('data-clamped');
          toggle.textContent = intro.getAttribute('data-less');
        } else {
          intro.setAttribute('data-clamped', 'true');
          toggle.textContent = intro.getAttribute('data-more');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
